import { useContext, useEffect, useState } from 'react'

import DataExportDialog from '/components/data-export-dialog'
import downloadTemplateData from '/components/make-passes/download-template-data'
import { AppContext } from '/providers/app-context'
import { getTemplateData } from '/providers/templates-api'

const TemplateDataExportDialog = ({ open, setOpen, template }) => {
  const { apiSource, apiKey } = useContext(AppContext)
  const [exportTemplate, setExportTemplate] = useState(template)
  const [loadingTemplateData, setLoadingTemplateData] = useState(false)

  useEffect(() => {
    let active = true
    setExportTemplate(template)

    if (!open || !template?.template_id || Array.isArray(template.variable_catalog)) {
      setLoadingTemplateData(false)
      return () => { active = false }
    }

    setLoadingTemplateData(true)
    getTemplateData({ apiSource, apiKey, templateId: template.template_id })
      .then(result => {
        if (active && result?.ok && result.template) setExportTemplate(result.template)
      })
      .finally(() => {
        if (active) setLoadingTemplateData(false)
      })

    return () => { active = false }
  }, [apiKey, apiSource, open, template])

  return <DataExportDialog
    open={open}
    setOpen={setOpen}
    fileName={`${exportTemplate?.template_id ?? 'template'}-default-variables`}
    onExport={format => downloadTemplateData({ template: exportTemplate, format })}
    exportDisabled={loadingTemplateData || !Array.isArray(exportTemplate?.variable_catalog)}
  />
}

export default TemplateDataExportDialog
